import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, Route, UrlSegment, CanLoad } from '@angular/router';
import { Observable } from 'rxjs';

import { UserPermissionsService } from '../services/user-permissions.service';
import { ToasterService } from '../modules/ui-components/toaster';

@Injectable({
  providedIn: 'root'
})
export class PermissionRetailGuard implements CanActivate, CanLoad {

  constructor(
    private router: Router,
    private userPermissionsService: UserPermissionsService,
    private toasterService: ToasterService
  ) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

    return this.userPermissionsService.canViewRetail();
  }

  canLoad(route: Route, segments: UrlSegment[]): Observable<boolean> | Promise<boolean> | boolean {

    if (!this.userPermissionsService.canViewRetail()) {
      // this.toasterService.notify({
      //   type: 'error',
      //   message: 'Looks like you have no access to retail documents. Get in touch with your workspace administrator if you want to get access.'
      // });
      this.router.navigate(['/no-access', {appName: 'retail'}]);
      return false;
    }

    return this.userPermissionsService.canViewRetail();
  }
}
